
export const DELETE_FILE = `
mutation DeleteFile($deleteFilesInput: DeleteInfo) {
  deleteFile(DeleteFilesInput: $deleteFilesInput) {
    statusCode
    message
  }
}`;